@if (isLoggedIn && !isFullBleed) {
  <app-sidebar/>
  <main class="ml-64 min-h-screen bg-base-200">
    <router-outlet/>
  </main>
  <!-- inside the admin chrome only: the public receipt page has no session and no bell -->
  <app-notification-toast/>
} @else {
  <!-- login, and the dealer-facing receipt, render without the admin chrome -->
  <router-outlet/>
}

<app-loading-indicator/>
